import React from "react"
import types from "prop-types"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const CloseSidebarIcon = ({ className = "w-8 h-8" }) => (
  <SvgSpriteIcon iconName="close-sidebar" className={className} />
)

CloseSidebarIcon.propTypes = {
  className: types.string,
}

export default CloseSidebarIcon
